export default {
  workshop: {
    breadcrumbHome: 'Home',
    breadcrumbSolutions: 'Soluzioni',
    breadcrumbCurrent: 'Officina e artigianato',
    hero: {
      eyebrow: 'Officina e artigianato',
      title: 'Tecnologia di sicurezza robusta per ambienti difficili',
      lead: 'Polvere, umidità, sbalzi di temperatura: le officine richiedono molto. Montiamo telecamere all’altezza.',
    },
    areas: {
      title: 'Aree di impiego in officina e artigianato',
      lead: 'Dall’area officina al cortile esterno: proteggiamo i tuoi preziosi attrezzi, macchinari e veicoli.',
      items: {
        '0': { title: 'Capannone', desc: 'Capannoni alti con macchinari richiedono telecamere robuste con buona risoluzione, anche con luce difficile.' },
        '1': { title: 'Area officina', desc: 'Attrezzi, ricambi e lavori in corso: la sorveglianza protegge lo spazio e chiarisce i reclami.' },
        '2': { title: 'Zona di carico', desc: 'Carico e scarico sono occasioni di furto. Le telecamere documentano ogni operazione in modo affidabile.' },
        '3': { title: 'Zona macchine', desc: 'La produzione moderna richiede documentazione completa dei processi, anche tra le macchine.' },
        '4': { title: 'Cortile e parcheggio', desc: 'Veicoli, rimorchi e materiali: il cortile richiede telecamere resistenti con buona visione notturna.' },
        '5': { title: 'Ufficio e amministrazione', desc: 'Offerte, fatture e dati clienti sono in ufficio. Anche qui la sicurezza non va trascurata.' },
      },
    },
    robust: {
      eyebrow: 'Robustezza',
      title: 'Costruito per l’uso intenso',
      lead: 'Le officine non sono showroom. Le nostre telecamere sono fatte per questi ambienti e scelte per le tue condizioni.',
      items: {
        '0': { title: 'Alta classe di protezione', desc: 'Custodie IP66 proteggono da polvere, spruzzi e pioggia, anche all’esterno continuo.' },
        '1': { title: 'Resistente a temperatura e umidità', desc: 'Dal magazzino gelido all’officina calda: scegliamo telecamere per ogni intervallo di temperatura.' },
        '2': { title: 'Custodie antipolvere', desc: 'In ambienti polverosi, custodie e guarnizioni speciali mantengono l’ottica pulita e nitida per anni.' },
      },
    },
    maintenance: {
      eyebrow: 'Manutenzione e assistenza',
      title: 'Affinché il tuo impianto resti affidabile',
      lead: 'In ambienti polverosi e difficili, la cura decide la durata. Con SSG Care il tuo impianto resta sempre pronto.',
      list: {
        '0': 'Controlli regolari di SSG Care, anche fuori garanzia',
        '1': 'Pulizia e ispezione visiva di custodia e obiettivo',
        '2': 'Aggiornamenti firmware e di sicurezza secondo necessità',
        '3': 'Reazione rapida a guasti o malfunzionamenti',
        '4': 'Opzioni di ricambi e potenziamento per il tuo impianto',
      },
      note: 'Nota: la liceità della videosorveglianza dipende dal caso. Ti consigliamo, senza sostituire la consulenza legale.',
    },
    cta: {
      title: 'La tua officina merita uno sguardo sicuro',
      lead: 'Ti consigliamo senza impegno quali telecamere regge il tuo ambiente e dove proteggono di più.',
      primary: 'Fissa un appuntamento di consulenza',
      secondary: 'Scopri SSG Care',
    },
  },
};